export default {
  namespaced: true,
  state: {
    overlayCount: 0,
    inviteGuestsOpen: false,
  },
  getters: {
    isOverlayOpen: (state) => state.overlayCount > 0,
    isInviteGuestsOpen: (state) => state.inviteGuestsOpen,
  },
  mutations: {
    incrementOverlay(state) {
      state.overlayCount += 1;
    },
    decrementOverlay(state) {
      state.overlayCount = Math.max(0, state.overlayCount - 1);
    },
    openInviteGuests(state) {
      state.inviteGuestsOpen = true;
    },
    closeInviteGuests(state) {
      state.inviteGuestsOpen = false;
    },
  },
};
